module.exports = __webpack_public_path__ + "img/f-2-3.140b66f.png";